export default "__VITE_ASSET__BPObYTtZ__"